import { useState } from 'react';
import { useDispatch } from 'react-redux';

import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';
import { PokerModalRoutes } from '@swf/core/types/Poker';
import type {
  CancelClubTableRequest,
  CancelClubTableResponse,
  HGCancelCashGameReply
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse, useHomeGamesWidget } from '@swf/poker';

export interface RequestBody {
  body: CancelClubTableRequest;
}

const useDeleteCashGame = (widgetId?: string) => {
  const request = useRequest();
  const { modal } = useDispatch<Dispatch>();
  const [loading, setLoading] = useState(false);
  const { widgetDispatch } = useHomeGamesWidget(widgetId);

  const handleDeleteCashGame = ({ body }: RequestBody) => {
    setLoading(true);
    request({ service: 'homeGames.cancelClubTableRequest', body }).subscribe({
      next: ({ body }: { body: CancelClubTableResponse }) => {
        const { error } = handleServerResponse<CancelClubTableResponse, HGCancelCashGameReply>({
          response: body,
          accessor: 'hgCancelCashGameReply'
        });
        setLoading(false);
        modal.close();

        if (error) {
          modal.enqueue({
            path: PokerModalRoutes.notification,
            locationState: { text: error }
          });
        } else {
          widgetDispatch.fetchClubInfo();
        }
      }
    });
  };

  return { handleDeleteCashGame, loading };
};

export default useDeleteCashGame;
